import React from "react";
import styled from "styled-components";
import { DatePicker } from "Components/Base/Inputs/DatePicker";
import { InputLabel } from "Components/Base/Inputs/InputLabel";
import { Box } from "Components/Base/Layout/Box";

const StyledOldLabel = styled.label`
  margin: 0 0 4px 0;
`;

const RequiredAsterisk = styled.span`
  color: var(--colorErrorDark);
  margin-left: 4px;
`;

const InputLabelDatePicker = ({
  id,
  label = false,
  name = "",
  required,
  nativeRequired,
  value,
  min,
  max,
  placeholder,
  disabled = false,
  onChange = () => {},
  onFocus = () => {},
  oldStyleLabel = false,
  error = false,
  helperText = "",
}) => {
  const useNativeRequired =
    nativeRequired === undefined ? Boolean(required) : nativeRequired;

  return (
    <Box display="flex" flexDirection="column">
      {oldStyleLabel && (
        <StyledOldLabel htmlFor={id}>
          {label}
          {required ? (
            <RequiredAsterisk aria-hidden="true">*</RequiredAsterisk>
          ) : null}
          :
        </StyledOldLabel>
      )}
      {!oldStyleLabel && (
        <Box mb={1} width="fit-content">
          <InputLabel htmlFor={id}>
            {label}
            {required ? (
              <RequiredAsterisk aria-hidden="true">*</RequiredAsterisk>
            ) : null}
          </InputLabel>
        </Box>
      )}
      <DatePicker
        id={id}
        name={name}
        value={value}
        required={useNativeRequired}
        {...(required ? { ariaRequired: true } : {})}
        error={error}
        helperText={helperText}
        placeholder={placeholder}
        {...(min && { min })}
        {...(max && { max })}
        onChange={onChange}
        onFocus={onFocus}
        disabled={disabled}
      />
    </Box>
  );
};

export default InputLabelDatePicker;
